import { PDFDocument } from 'pdf-lib';


const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export function mailingMatrixService(data) {
  const service = data?.mailingMatrixService;
  return service?.enabled && service?.matrix_id ? service : null;
}

const normalizedAddressKey = recipient => [
  recipient?.name,
  recipient?.street1,
  recipient?.street2,
  recipient?.city,
  recipient?.state,
  recipient?.zip_code,
]
  .map(value => String(value || '').trim().toLowerCase())
  .join('|');

export function amendmentAdditionalRecipients(data) {
  return (data?.amendedCreditors || []).filter(recipient => recipient?.method);
}

export function amendmentServiceRecipients(data) {
  const service = mailingMatrixService(data);
  if (service) {
    const recipients = new Map();
    (service.recipients || []).forEach(recipient => {
      recipients.set(normalizedAddressKey(recipient), {
        ...recipient,
        method: service.method || 'USM',
      });
    });
    // A specifically selected recipient overrides the matrix-wide method. This
    // permits certified service to one creditor while the full matrix uses USM.
    amendmentAdditionalRecipients(data).forEach(recipient => {
      recipients.set(normalizedAddressKey(recipient), recipient);
    });
    return Array.from(recipients.values());
  }
  return amendmentAdditionalRecipients(data);
}

export function amendmentServiceDescription(data) {
  const service = mailingMatrixService(data);
  if (service) {
    const matrixDescription = service.method === 'Certified'
      ? 'all creditors on the attached mailing list by certified mail'
      : 'all creditors on the attached mailing list by United States first class mail';
    return amendmentAdditionalRecipients(data).length > 0
      ? `${matrixDescription}, plus the creditors on the supplemental service list by the method shown there`
      : matrixDescription;
  }
  return amendmentAdditionalRecipients(data).length > 0
    ? 'attached on the following list of creditors'
    : 'No additional creditors were served.';
}

export function caseFilingNoticeServiceLabel(data) {
  const docketNumber = data?.caseFilingNotice?.docket_number;
  if (!docketNumber) return '';
  return `Notice of Bankruptcy Case [Doc. ${docketNumber}] with full SSNs on mailed service copies`;
}

export async function appendAmendmentServiceList(targetPdf, data, generateFallbackList) {
  const service = mailingMatrixService(data);
  let sourcePdf;
  if (service) {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${API_URL}${service.pdf_url}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) {
      throw new Error('The saved creditor mailing matrix could not be attached.');
    }
    sourcePdf = await PDFDocument.load(await response.arrayBuffer(), { ignoreEncryption: true });
  } else {
    sourcePdf = await generateFallbackList(amendmentAdditionalRecipients(data));
  }
  const pages = await targetPdf.copyPages(sourcePdf, sourcePdf.getPageIndices());
  pages.forEach(page => targetPdf.addPage(page));

  const additionalRecipients = amendmentAdditionalRecipients(data);
  if (service && additionalRecipients.length > 0) {
    const supplementalPdf = await generateFallbackList(additionalRecipients);
    const supplementalPages = await targetPdf.copyPages(
      supplementalPdf,
      supplementalPdf.getPageIndices(),
    );
    supplementalPages.forEach(page => targetPdf.addPage(page));
  }
}
